import { Longhand } from "../longhand.js";
import Base, { compute } from "./border-top-width.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-bottom-width}
 * @internal
 */
export default Longhand.extend(Base, {
    compute: (borderWidth, style) => {
        const borderStyle = style.computed("border-bottom-style");
        return compute(borderStyle, borderWidth, style);
    },
});
//# sourceMappingURL=border-bottom-width.js.map